import { axios } from "utils";

import { ADMIN_FARMS_URL as endpoint } from "consts";

import { FarmAreaSummaryResponse, FarmDataSubmissionStatusAdminResponse, FieldShape, UpdateFarmDataSubmissionAdminResponse } from "models";

// farms

export const getAllFarms = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}`, { data });

export const getFullFarmDetails = async (data: { id: string }) => axios.get(`${endpoint}/${data.id}`, { data });

export const getFarmAreaSummary = async ({ farmId }: { farmId: string }): Promise<FarmAreaSummaryResponse> => axios.get(`${endpoint}/${farmId}/summary`);

export const toggleTest = async (data: { farmId: string; signal: AbortSignal }) => axios.put(`${endpoint}/${data.farmId}/test`, { data });

export const getFieldShapesAdmin = async (data: { farmId: string; signal?: AbortSignal }): Promise<{ success: true; fieldShapes: FieldShape[] }> =>
  axios.get(`${endpoint}/${data.farmId}/fields/shapes`, { data });

export const getAllInvekos = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}/invekos`, { data });

// pipedrive

export const updateDealById = async (data: { dealId: string; signal: AbortSignal }) => axios.put(`${endpoint}/deals/${data.dealId}`, { data });

export const linkDealToFarm = async (data: { signal: AbortSignal }) => axios.post(`${endpoint}/deals`, { data });

// data submission

export const updateFarmDataSubmissionAdmin = async (data: { farmId: string; submissionState: boolean }): Promise<UpdateFarmDataSubmissionAdminResponse> =>
  axios.put(`${endpoint}/submissions`, { data });

export const getFarmDataSubmissionStatusAdmin = async (data: { farmId: string; signal: AbortSignal }): Promise<FarmDataSubmissionStatusAdminResponse> =>
  axios.get(`${endpoint}/submissions/${data.farmId}`, { signal: data.signal });
